import * as client_hooks from '../../../src/hooks.client.ts';
import * as universal_hooks from '../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41')
];

export const server_loads = [0,2,4,5];

export const dictionary = {
		"/authentication/login-callback": [31],
		"/authentication/login": [30],
		"/authentication/sf-signout": [32],
		"/booking/[...path]": [33],
		"/(map)/map/filters": [12,[2,3]],
		"/(map)/map/[[category=poiCategory]]/poi/[...poi]": [~11,[2,3,4]],
		"/(map)/map/traffic/[...address]": [~13,[2,3]],
		"/(map)/map/[[category=poiCategory]]/[...address]": [~10,[2,3,4]],
		"/mobile/print": [~34],
		"/mobile/roadsheet": [35],
		"/print": [36],
		"/profile": [37,[9]],
		"/profile/animation": [38,[9]],
		"/profile/favorites": [39,[9]],
		"/profile/information": [40,[9]],
		"/profile/settings": [41,[9]],
		"/(map)/routes": [~14,[2,5]],
		"/(map)/routes/(details)/costs": [15,[2,5,6]],
		"/(map)/routes/(details)/costs/edit": [16,[2,5,6]],
		"/(map)/routes/(details)/instructions": [17,[2,5,6]],
		"/(map)/routes/(details)/on-the-way": [18,[2,5,6]],
		"/(map)/routes/(details)/on-the-way/filters": [19,[2,5,6]],
		"/(map)/routes/(details)/on-the-way/poi": [20,[2,5,6]],
		"/(map)/routes/results/[...addresses]": [~28,[2,5]],
		"/(map)/routes/search-car": [29,[2,5]],
		"/(map)/routes/(details)/search": [21,[2,5,6,7]],
		"/(map)/routes/(details)/search/filters": [22,[2,5,6,7]],
		"/(map)/routes/(details)/search/poi": [23,[2,5,6,7]],
		"/(map)/routes/(details)/zoi": [24,[2,5,6]],
		"/(map)/routes/(details)/zoi/filters": [25,[2,5,6]],
		"/(map)/routes/(details)/zoi/poi": [26,[2,5,6]],
		"/(map)/routes/(details)/zoi/settings": [27,[2,5,6,8]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';